import { render, staticRenderFns } from "./tesetPassword.vue?vue&type=template&id=2b755ceb&scoped=true&"
import script from "./tesetPassword.vue?vue&type=script&lang=js&"
export * from "./tesetPassword.vue?vue&type=script&lang=js&"
import style0 from "./tesetPassword.vue?vue&type=style&index=0&id=2b755ceb&lang=less&scoped=true&"
import style1 from "./tesetPassword.vue?vue&type=style&index=1&id=2b755ceb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b755ceb",
  null
  
)

export default component.exports